import image from '../assets/11_360x.webp'
import image1 from '../assets/222_360x.webp'
import image2 from '../assets/11_360x.webp'
import image3 from '../assets/33_360x.webp'

export const featured = [
    {
        id: '1',
        icon: <i className='fas fa-car-side fa-3x'></i>,
        name: "Free Shipping",
        desc: "Free on order over $300",
    },
    {
        id: '2',
        icon: <i className='fas fa-user-shield fa-3x'></i>,
        name: "Security Payment",
        desc: "100% security payment",
    },
    {
        id: '3',
        icon: <i className='fas fa-exchange-alt fa-3x'></i>,
        name: "30 Day Return",
        desc: "30 day money guarantee",
    },
    {
        id: '4',
        icon: <i className='fa fa-phone fa-3x'></i>,
        name: "24/7 Support",
        desc: "Support every time fast",
    },
]



export const orderingProcess = [
  {
    id: 1,
    img: `${image}`,
    title: "Upload Your Artwork & Order Online",
    desc: "Upload your design, select patch type, size, and quantity, and place your order online in just a few minutes—no emails or calls needed."
  },
  {
    id: 2,
    img: `${image1}`,
    title: "Review & Approve Your Patch Design",
    desc: "Review a digital mockup of your patch, request changes if needed, and approve the final design before production begins."
  },
  {
    id: 3,
    img: `${image2}`,
    title: "We Produce & Ship Your Patch Order",
    desc: "We produce your custom patches with care and ship them quickly to your doorstep with full tracking."
  },
  {
    id: 4,
    img: `${image3}`,
    title: "Press at Your Pace And Store the Rest Forever",
    desc: "Apply your patches at your own pace using heat, sewing, or Velcro, and safely store any extras for future use."
  }
];


export const singleProduct = {
  id: 1,
  name: "Custom Embroidered Patches",
  shortDesc:
    "Create timeless designs with customizable embroidered patches. Perfect for jackets, hats, uniforms, and more.",

  rating: 4,
  soldText: "6 sold in last 10 hours",

  basePrice: 4.13,
  discountedPrice: 2.27,

  image: "/img/single-item.jpg",

  galleryImages: [
    "/img/single-item.jpg",
    "/img/single-item2.jpg",
    "/img/single-item3.jpg",
  ],

  upload: {
    title: "Drop files here",
    types: "JPEG, PNG (Max 5MB)",
  },

  shapes: [
    "Custom Shape",
    "Circle",
    "Square",
    "Rectangle",
    "Crest",
    "Diamond",
    "Oval",
  ],

  borders: ["Hot Cut", "Merrow"],

  backings: ["Heat Applied", "Velcro", "Sew On", "Adhesive"],

  colorOptions: {
    borderColor: "#000000",
    backgroundColor: "#ffffff",
  },

  size: { min: 2, max: 10 },

  qtyPricing: [
    { qty: "25–49", discount: "16% off", price: "$3.47 ea" },
    { qty: "50–99", discount: "37% off", price: "$2.60 ea" },
    { qty: "100–199", discount: "45% off", price: "$2.27 ea" },
    { qty: "200–499", discount: "62% off", price: "$1.57 ea" },
    { qty: "500–999", discount: "71% off", price: "$1.20 ea" },
    { qty: "1000+", discount: "74% off", price: "$1.07 ea" },
  ],

  description: {
    heading:
      "Welcome to Personalized Patches for Hats – Your Destination for Custom Embroidered Patches",
    paragraph:
      "At Personalized Patches for Hats, we craft premium embroidered patches that bring your vision to life — fast, affordable, and high-quality.",
    features: [
      "Precision-driven quality",
      "Made-to-order embroidered patches",
      "Wholesale discounts available",
      "Fast USA-based delivery",
    ],
  },

  additionalInfo: {
    title: "Additional Information",
    points: [
      "Thread Colors: Up to 12 included",
      "Backings: Heat Applied, Velcro, Sew On, Adhesive",
      "Borders: Hot Cut, Merrow",
      "Sizes: 2″ – 10″",
    ],
  },

  shipping: {
    title: "Shipping & Return",
    points: [
      "Free shipping for orders over $180.",
      "Production time: 5–12 business days.",
      "45-day replacement guarantee for production errors.",
    ],
  },
};


export const cartDetails = {
  "Patch Size (inches)": `4"`,
  "Width (in)": "3.81",
  "Height (in)": "3.25",
  "Rectangle Corner Style": "Rounded",
  "Patch Background Color": "56",
  "Border Style Rectangle": "Embroidered / Hot Cut (Most Popular)",
  "Border Thread Color": "43",
  "Select Your Backing": "Heat Applied (Most Popular)",
  "Select Shape": "Rectangle",
  "Upload": "Preview",
  "Discount": "44% off for 100+ patches",
};



export const products = [
  {
    id: 1,
    category: "EMBROIDERY",
    img: "/img/embroidered.png",
    name: "Custom Embroidered Patches",
    price: 1.07
  },
  {
    id: 2,
    category: "PVC RUBBER",
    img: "/img/pvc.png",
    name: "PVC Rubber Patches",
    price: 1.42
  },
  {
    id: 3,
    category: "WOVEN",
    img: "/img/woven.png",
    name: "Woven Patch",
    price: 1.24
  },
  {
    id: 4,
    category: "LEATHER",
    img: "/img/leather.png",
    name: "Genuine Leather",
    price: 1.17
  }
];



export const vegetables = [
    {
        id: '1',
        img: '../img/vegetable-item-1.jpg',
        name: 'Fresh Tomato',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '5.40',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '2',
        img: '../img/vegetable-item-5.jpg',
        name: 'Potato',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '3.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '3',
        img: '../img/vegetable-item-1.jpg',
        name: 'Tomato',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '4.50',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '4',
        img: '../img/vegetable-item-4.jpg',
        name: 'Pepper',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '6.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '5',
        img: '../img/vegetable-item-5.jpg',
        name: 'Potato',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '4.29',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '6',
        img: '../img/vegetable-item-6.jpg',
        name: 'Parsley',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '5.10',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '7',
        img: '../img/vegetable-item-4.jpg',
        name: 'Pepper',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '2.90',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '8',
        img: '../img/vegetable-item-6.jpg',
        name: 'Parsley',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt',
        price: '4.10',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
]

export const bsetseller = [
    {
        id: '1',
        img: '../img/fruite-item-1.jpg',
        name: 'Organic Orange',
        star: <i className="fas fa-star"></i>,
        price: '5.40',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '2',
        img: '../img/fruite-item-2.jpg',
        name: 'Organic Raspberry',
        star: <i className="fas fa-star"></i>,
        price: '4.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '3',
        img: '../img/fruite-item-3.jpg',
        name: 'Organic Banana',
        star: <i className="fas fa-star"></i>,
        price: '4.70',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '4',
        img: '../img/fruite-item-4.jpg',
        name: 'Organic Apricots',
        star: <i className="fas fa-star"></i>,
        price: '6.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '5',
        img: '../img/fruite-item-5.jpg',
        name: 'Organic Grapes',
        star: <i className="fas fa-star"></i>,
        price: '3.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
    {
        id: '6',
        img: '../img/fruite-item-6.jpg',
        name: 'Organic Appels',
        star: <i className="fas fa-star"></i>,
        price: '5.99',
        icon: <i className='fa fa-shopping-bag'></i>,
        cart: 'Add to Cart'
    },
]

export const fact = [
    {
        id: '1',
        name: 'satisfied customers',
        num: '1963',
        icon: <i className='fa fa-users'></i>,
    },
    {
        id: '2',
        name: 'quality of service',
        num: '99%',
        icon: <i className='fa fa-users'></i>,
    },
    {
        id: '3',
        name: 'quality certifications',
        num: '33',
        icon: <i className='fa fa-users'></i>,
    },
    {
        id: '4',
        name: 'available products',
        num: '789',
        icon: <i className='fa fa-users'></i>,
    },
]

export const testimonial = [
    {
        id: '1',
        desc: 'Lorem Ipsum is simply dummy text of the printing Ipsum has been the industrys standard dummy text ever since the 1500s.',
        img: '../img/testimonial-1.jpg',
        name: 'Client Name',
        star: <i className="fas fa-star"></i>,
        prof: 'Profession',
        icon: <i className='fa fa-quote-right fa-2x' style={{color: '#ffb524'}}></i>
    },
    {
        id: '2',
        desc: 'Lorem Ipsum is simply dummy text of the printing Ipsum has been the industrys standard dummy text ever since the 1500s.',
        img: '../img/testimonial-2.jpg',
        name: 'Client Name',
        star: <i className="fas fa-star"></i>,
        prof: 'Profession',
        icon: <i className='fa fa-quote-right fa-2x' style={{color: '#ffb524'}}></i>
    },
]

export const shop_feature = [
    {
        id: '1',
        img: '../img/featur-1.jpg',
        name: 'Big Apples',
        star: <i className="fas fa-star"></i>,
        price: '5.40 $',
        delete: '4.11 $'
    },
    {
        id: '2',
        img: '../img/featur-2.jpg',
        name: 'Big Straw',
        star: <i className="fas fa-star"></i>,
        price: '4.99 $',
        delete: '4.11 $'
    },
    {
        id: '3',
        img: '../img/featur-3.jpg',
        name: 'Big Carnap',
        star: <i className="fas fa-star"></i>,
        price: '4.70 $',
        delete: '4.11 $'
    },
    {
        id: '4',
        img: '../img/featur-1.jpg',
        name: 'Big Apples',
        star: <i className="fas fa-star"></i>,
        price: '5.40 $',
        delete: '4.11 $'
    },
    {
        id: '5',
        img: '../img/featur-2.jpg',
        name: 'Big Straw',
        star: <i className="fas fa-star"></i>,
        price: '4.99 $',
        delete: '4.11 $'
    },
    {
        id: '6',
        img: '../img/featur-3.jpg',
        name: 'Big Carnap',
        star: <i className="fas fa-star"></i>,
        price: '4.70 $',
        delete: '4.11 $'
    },
]